export const pickerOptions = {
    firstDayOfWeek: 1
};

export default pickerOptions;
